(function () {
  const SELECTOR = '.radio__fieldset.option_size';
  const DRAG_THRESHOLD = 5; // px before it counts as a drag, not a click

  function enhance(el) {
    if (!el || el.dataset.scrollEnhanced) return;
    el.dataset.scrollEnhanced = 'true';

    /* ---------- wheel ---------- */
    el.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 1) return;

      let delta = e.deltaY;
      if (e.deltaMode === 1) delta *= 16;
      else if (e.deltaMode === 2) delta *= el.clientWidth;

      const next = Math.max(0, Math.min(maxScroll, el.scrollLeft + delta));
      if (next === el.scrollLeft) return;

      el.scrollLeft = next;
      e.preventDefault();
    }, { passive: false });

    /* ---------- drag ---------- */
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragging = false;   // threshold exceeded
    let justDragged = false; // swallow the click that follows

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // touch scrolls natively
      if (e.button !== 0) return;
      if (el.scrollWidth - el.clientWidth <= 1) return;

      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      dragging = false;
      justDragged = false;
    });

    el.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pointerId) return;

      const dx = e.clientX - startX;

      if (!dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        dragging = true;
        el.setPointerCapture(pointerId); // capture only once it's a real drag
        el.classList.add('is-dragging');
      }

      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function endDrag(e) {
      if (e.pointerId !== pointerId) return;
      if (dragging) {
        justDragged = true;
        el.classList.remove('is-dragging');
        if (el.hasPointerCapture(pointerId)) el.releasePointerCapture(pointerId);
      }
      pointerId = null;
      dragging = false;
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);

    // swallow the synthetic click after a drag so the <a> doesn't navigate
    el.addEventListener('click', function (e) {
      if (!justDragged) return;
      justDragged = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // the swatches contain <img> and <svg> — stop native image dragging
    el.addEventListener('dragstart', function (e) {
      if (dragging) e.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/****** size variant arrow*********/

(function () {
  const arrowSvg = dir => `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="${dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6'}"></polyline>
    </svg>`;

  function initSizeSlider(track) {
    if (track.closest('.size-slider-wrap')) return; // already set up

    const wrap = document.createElement('div');
    wrap.className = 'size-slider-wrap';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'size-slider-arrow prev';
    next.className = 'size-slider-arrow next';
    prev.setAttribute('aria-label', 'Previous sizes');
    next.setAttribute('aria-label', 'Next sizes');
    prev.innerHTML = arrowSvg('prev');
    next.innerHTML = arrowSvg('next');
    wrap.append(prev, next);

    const step = () => {
      const card = track.querySelector('.main-product__swatch-button');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Scroll the selected size into view on load
    const selected = track.querySelector('.product-variant-options.selected');
    if (selected) {
      const card = selected.closest('.main-product__swatch-button');
      track.scrollLeft = card.offsetLeft - track.offsetLeft - 10;
    }
    update();
  }

  function initAll() {
    document.querySelectorAll('.radio__fieldset.option_size').forEach(initSizeSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // Re-run if the theme re-renders the product section (e.g. quick view)
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
